export default __webpack_public_path__ + "static/media/sales-up.405ed22a.webp";